import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Flex, Form, Input, Row, Steps, Typography, message, notification } from 'antd'
import { BUTTON, TEXT } from '../../../layout/style';
import ForgetPasswordEmail from './Components/ForgetPasswordEmail';
import validateForm from '../../../utils/FormValidation';
import validationRules from '../../../assets/validation/rules';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import { Link } from 'react-router-dom';
const { Text, Title } = Typography;


export default function ForgetPassword() {
    const [api, contextHolder] = notification.useNotification();
    const [payload, setPayload] = useState({
        email: "",
    });
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState(false);
    const [timer, setTimer] = useState(0);
    function validateFormData(data) {
        const validationResult = validateForm(data, validationRules)
        if (!validationResult.isValid) {
            const err = validationResult.errors
            const newErrors = {};
            Object.keys(err).forEach((value) => {
                newErrors[value] = err[value];
            })
            setErrors(prev => ({ ...prev, ...newErrors }));
        } else {
            const keyData = Object.keys(data)[0]
            setErrors(prev => ({ ...prev, [keyData]: '' }))
        }
    }

    const submitHandler = async () => {
        const validationResult = validateForm(payload, validationRules)
        if (!validationResult.isValid) {
            const err = validationResult.errors
            const newErrors = {};
            Object.keys(err).forEach((value) => {
                newErrors[value] = err[value];
            })
            setErrors(newErrors);

            openNotificationWithIcon('error', "Validation", Object.values(err)[0], 'topRight')

        } else {
            AuthRestAPI.forgetPwd(payload).then((res) => {                
                openNotificationWithIcon('success', 'Email sent!', 'Please check your email for a password reset link.', 'topRight');
                setStatus(true);
                setTimer(180);
            }).catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'Error', `${err.response.data.message}`, 'topRight');
                } else {
                    openNotificationWithIcon('error', 'Error', `${err.message}`, 'topRight');
                }
            })
        }

    }

    useEffect(() => {
        let timeout;
        if (status && timer > 0) {
            timeout = setTimeout(() => {
                setTimer(timer - 1);
            }, 1000);
        } else if (timer === 0) {
            setStatus(false);
        }
        return () => clearTimeout(timeout);
    }, [timer, status]);

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };


    return (
        <div>
            <Row>
                <Col>
                    <h1 style={TEXT.heading1}>Forgot Password </h1>
                </Col>
            </Row>
            <br/>

            <Row>
                <Col xs={{
                    span: 20,
                }}
                    md={{
                        span: 18,
                    }}
                    lg={{
                        span: 16,
                    }}>
                    <div >
                        <Text type='secondary'>
                            Please enter the email address associated with your account. We’ll send you a link to help you reset your password.                            
                        </Text>
                        <br/>
                        <br/>
                        <Form name="basic">
                            <Form.Item
                                validateStatus={errors.email ? 'error' : ''}
                                help={errors.email || ''}
                            >
                                <Input size="large" placeholder="Email"
                                    onChange={(e) => {
                                        const sanitizedEmail = e.target.value.toLowerCase().trim();
                                        const validateData = {
                                            email: sanitizedEmail
                                        }
                                        validateFormData(validateData);
                                        setPayload(prev => ({
                                            ...prev,
                                            email: sanitizedEmail
                                        }));
                                    }}
                                    value={payload["email"]}
                                    autoComplete="new-email"
                                />
                            </Form.Item>
                        </Form>
                    </div>
                    <div
                        style={{
                            marginTop: 24,
                        }}
                    >
                        <Button disabled={status} style={BUTTON.primary} type="primary" onClick={submitHandler}>
                            {status ? `Resend (${timer})` : "Submit"}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Divider/>
            <Flex align='center'>
                Remember your password ? Go back to the <Link to='/login'> <Button type='link'>Login</Button></Link>
            </Flex>
            <Row>
                {contextHolder}
            </Row>
        </div>
    )
}